export default {
  getRequestById: state => id => {
    var ind = state.requests.findIndex(x => x.id == id);
    if (ind != -1 && ind != undefined) {
      return state.requests[ind];
    }
    else return null
  },

  requestAnswers:state=>reqId=>{
      return state.requestAnswers.filter(x => x.requestId == reqId);
  }
}
